import * as moment from 'moment/moment';
import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const creationDateRangeValidator: ValidatorFn = (fg: UntypedFormGroup) => {
  if (!fg.get('creationDateFrom') || !fg.get('creationDateTo')) {
    return null;
  }
  const from = fg.get('creationDateFrom').value;
  const to = fg.get('creationDateTo').value;
  if (!from || !to) {
    fg.get('creationDateTo').setErrors(null);

    return null;
  }
  const valid = from && to && moment(from) <= moment(to);

  fg.get('creationDateFrom').markAsTouched();
  fg.get('creationDateTo').markAsTouched();

  if (!valid) {
    fg.get('creationDateTo').setErrors({ range: true });
  } else {
    fg.get('creationDateTo').setErrors(null);
  }

  return valid ? null : { range: true };
};
